module.exports = __webpack_public_path__ + "img/largeloader_driving.4278b036.svg";